import classnames from "classnames";
import styles from "./styles.module.scss";
import { Card, CardContent, Stack } from "@altimateai/lego";
import { useState, useMemo } from "react";
import { DebouncedInput } from "../../components/form";
import { ColumnDatatype } from "../../components/column";
import { ColorTag } from "../../components/tags";
import classNames from "classnames";
import { DbtColumn, DbtModel } from "@/types/dbtModels";

const ColumnCard = ({ column }: { column: DbtColumn }) => {
  return (
    <div className={styles.column_card}>
      <Stack align="center">
        <ColumnDatatype datatype={column.datatype} />
        <div className="ms-2">{column.name}</div>
        <div className="spacer" />
        <ColorTag label={column.datatype} color={styles.column_tag} />
      </Stack>
      <div className="mb-1 divider" />
      <Stack align="center" justify="between">
        <Stack gap="xs" align="center">
          <div>Description</div>
        </Stack>
      </Stack>
      <div className="text-muted font-normal">{column.description}</div>
    </div>
  );
};

const HeaderSection = ({ table }: { table: DbtModel }) => {
  return (
    <Stack align="center">
      <div className={styles.column_table_name}>{table.model_name}</div>
    </Stack>
  );
};

const ColumnSection = ({ columns }: { columns: DbtColumn[] }) => {
  const [search, setSearch] = useState("");
  const filteredColumns = useMemo(() => {
    if (!search) return columns;
    const _search = search.toLowerCase();
    return columns.filter((c: DbtColumn) => c.name.includes(_search));
  }, [columns, search]);
  return (
    <Card className={classnames(styles.column_section, "mb-0", styles.bg_gray)}>
      <CardContent className={classNames(styles.column_body, "al-pt-4")}>
        <Stack direction="column" gap="sm">
          <Stack justify="between" align="center" className="mb-1">
            <Stack justify="between" align="center" gap="sm">
              <div className="fs-5 fw-semibold">Columns</div>
              <div className={styles.searchBox}>
                <DebouncedInput
                  size="sm"
                  placeholder="Search column"
                  onChange={setSearch}
                  aria-label="Search columns"
                />
              </div>
            </Stack>
            {search ? (
              <div className="text-primary">{filteredColumns.length} results found</div>
            ) : (
              <div>{columns.length} columns</div>
            )}
          </Stack>
          <div className={styles.grid}>
            <div className={styles.columnGrid}>
              {filteredColumns.map((c: DbtColumn) => (
                <ColumnCard key={c.rk} column={c} />
              ))}
            </div>
          </div>
        </Stack>
      </CardContent>
    </Card>
  );
};

const PurposeSection = ({ purpose }: { purpose: string }) => {
  return (
    <>
      {/* <Card className={classNames("mb-0", styles.bg_gray)}>
        <CardBody className="al-flex al-flex-col gap-sm">
          <div className="al-flex gap-xs al-items-center al-justify-between">
            <div className="fs-5 fw-semibold">
              Generate Description for the table and columns
            </div>
          </div>
        </CardBody>
      </Card> */}

      <Card className={styles.table_description}>
        <CardContent className="al-pt-4">
          <Stack gap="xs" align="center" className="mb-2">
            <div className="fw-semibold">Description</div>
            <div className="spacer" />
          </Stack>
          <div>
            <div className="text-muted font-normal">{purpose}</div>
          </div>
        </CardContent>
      </Card>
    </>
  );
};

const Schema = ({ table }: { table: DbtModel }) => {
  return (
    <Stack direction="column" gap="md" className="al-h-full">
      <HeaderSection table={table} />
      {table.description && <PurposeSection purpose={table.description as string} />}
      <div className="mb-1"></div>
      <ColumnSection columns={table.columns} />
    </Stack>
  );
};

export { Schema };
